"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnOrderSignifydSchema = void 0;
exports.ReturnOrderSignifydSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        recordId: {
            type: 'string',
            minLength: 1,
        },
        messageId: {
            type: 'string',
            minLength: 1,
        },
        sObjectName: {
            type: 'string',
            minLength: 1,
        },
        salesChannelName: {
            type: 'string',
            minLength: 1,
        },
    },
    required: ['recordId'],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmV0dXJuLW9yZGVyLXNpZ25pZnlkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2RvbXMvc2NoZW1hcy9yZXR1cm4tb3JkZXItc2lnbmlmeWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSx5QkFBeUIsR0FBRztJQUNyQyxPQUFPLEVBQUUseUNBQXlDO0lBQ2xELFVBQVUsRUFBRTtRQUNSLFFBQVEsRUFBRTtZQUNOLElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDZjtRQUNELFNBQVMsRUFBRTtZQUNQLElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDZjtRQUNELFdBQVcsRUFBRTtZQUNULElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDZjtRQUNELGdCQUFnQixFQUFFO1lBQ2QsSUFBSSxFQUFFLFFBQVE7WUFDZCxTQUFTLEVBQUUsQ0FBQztTQUNmO0tBQ0o7SUFDRCxRQUFRLEVBQUUsQ0FBQyxVQUFVLENBQUM7SUFDdEIsSUFBSSxFQUFFLFFBQVE7Q0FDakIsQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBSZXR1cm5PcmRlclNpZ25pZnlkU2NoZW1hID0ge1xuICAgICRzY2hlbWE6ICdodHRwOi8vanNvbi1zY2hlbWEub3JnL2RyYWZ0LTA3L3NjaGVtYSMnLFxuICAgIHByb3BlcnRpZXM6IHtcbiAgICAgICAgcmVjb3JkSWQ6IHtcbiAgICAgICAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgICAgICAgICAgbWluTGVuZ3RoOiAxLFxuICAgICAgICB9LFxuICAgICAgICBtZXNzYWdlSWQ6IHtcbiAgICAgICAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgICAgICAgICAgbWluTGVuZ3RoOiAxLFxuICAgICAgICB9LFxuICAgICAgICBzT2JqZWN0TmFtZToge1xuICAgICAgICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgICAgICAgICBtaW5MZW5ndGg6IDEsXG4gICAgICAgIH0sXG4gICAgICAgIHNhbGVzQ2hhbm5lbE5hbWU6IHtcbiAgICAgICAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgICAgICAgICAgbWluTGVuZ3RoOiAxLFxuICAgICAgICB9LFxuICAgIH0sXG4gICAgcmVxdWlyZWQ6IFsncmVjb3JkSWQnXSxcbiAgICB0eXBlOiAnb2JqZWN0Jyxcbn1cbiJdfQ==